import { getAllEnvironments, EnvironmentConfig } from './environments';
import { 
  initializeFirebase, 
  getCurrentAuth, 
  getCurrentDb 
} from './firebaseManager';

// Get the environment from localStorage if available, otherwise use build-time env
const ENV_STORAGE_KEY = 'glisten-admin-selected-environment';
const getInitialEnvironment = (): EnvironmentConfig => {
  const savedEnv = localStorage.getItem(ENV_STORAGE_KEY);
  if (savedEnv) {
    const env = getAllEnvironments().find(e => e.name === savedEnv);
    if (env) {
      console.log(`Loaded saved environment from localStorage: ${env.displayName}`);
      return env;
    }
  }
  
  // Fall back to build-time environment
  const buildEnv = process.env.REACT_APP_ENV || 'development';
  const env = getAllEnvironments().find(e => e.name === buildEnv) || getAllEnvironments()[0];
  console.log(`Using build-time environment: ${env.displayName}`);
  return env;
};

// Get and initialize the environment
const env = getInitialEnvironment();

// Initialize Firebase for the selected environment
initializeFirebase(env);

// Export auth and db
export const auth = getCurrentAuth();
export const db = getCurrentDb();

// Export for components that need to switch environments
export { initializeFirebase } from './firebaseManager';

export const currentEnv = env; 